import React, { useState, useEffect } from 'react';
import { useResponsive } from '../../hooks/useResponsive';

interface CancelMatchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  isLoading?: boolean;
  matchLocation?: string;
}

const MAX_LEN = 500;

export const CancelMatchModal: React.FC<CancelMatchModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading = false,
  matchLocation,
}) => {
  const { isMobile } = useResponsive();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) setReason('');
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: isMobile ? '10px' : '20px',
      }}
      onClick={() => !isLoading && onClose()}
      role="presentation"
    >
      <div
        style={{
          backgroundColor: '#23272A',
          borderRadius: isMobile ? '12px' : '16px',
          padding: isMobile ? '16px' : '24px',
          maxWidth: isMobile ? 'calc(100vw - 20px)' : '480px',
          width: '100%',
          border: '1px solid #33383B',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
        }}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        <div style={{ marginBottom: '16px', textAlign: 'center' }}>
          <div style={{ fontSize: '32px', marginBottom: '4px' }}>❌</div>
          <h2
            style={{
              color: '#FFFFFF',
              margin: '0 0 8px 0',
              fontSize: isMobile ? '18px' : '20px',
              fontWeight: 'bold',
            }}
          >
            Cancelar partido
          </h2>
          <p
            style={{
              color: '#B0BEC5',
              margin: 0,
              fontSize: isMobile ? '13px' : '14px',
              lineHeight: '1.4',
            }}
          >
            {matchLocation
              ? `Se marcará el partido en ${matchLocation} como cancelado y se avisará a todos los anotados.`
              : 'Se marcará el partido como cancelado y se avisará a todos los anotados.'}
          </p>
        </div>

        <label
          style={{
            display: 'block',
            color: '#FFFFFF',
            fontSize: '13px',
            fontWeight: 600,
            marginBottom: '6px',
          }}
        >
          Motivo (se incluye en el aviso)
        </label>
        <textarea
          value={reason}
          onChange={(e) => e.target.value.length <= MAX_LEN && setReason(e.target.value)}
          placeholder="Ej: la cancha se canceló por falta de personal. Vemos de reprogramar."
          disabled={isLoading}
          rows={4}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: '#1a1a1a',
            border: '1px solid #33383B',
            borderRadius: '8px',
            padding: '12px',
            color: '#FFFFFF',
            fontSize: '14px',
            resize: 'vertical',
            fontFamily: 'inherit',
          }}
        />
        <div style={{ textAlign: 'right', color: '#6B7280', fontSize: '11px', marginTop: '4px' }}>
          {reason.length}/{MAX_LEN}
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
          <button
            onClick={onClose}
            disabled={isLoading}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: 'transparent',
              color: '#FFFFFF',
              border: '1px solid #33383B',
              borderRadius: '8px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: '15px',
              fontWeight: 600,
            }}
          >
            Volver
          </button>
          <button
            onClick={() => onSubmit(reason)}
            disabled={isLoading}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: '#F44336',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: '15px',
              fontWeight: 700,
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {isLoading ? 'Cancelando…' : 'Cancelar partido'}
          </button>
        </div>
      </div>
    </div>
  );
};
